import React from 'react'

import { gql } from '../../../../../../__generated__/graphql/catalog/gql'
import { NextLink } from '../../../../../../app/_components/navigation/NextLink'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import { Container, SelectedGender } from './styles'

import type { GenderNavSectionFragmentFragment } from '../../../../../../__generated__/graphql/catalog/graphql'

export const GENDER_NAV_SECTION_FRAGMENT = gql(`
  fragment GenderNavSectionFragment on GenderNavSection {
    id
    alternateGenderHandle
    selectedGender
  }
`)

export type GenderNavSectionProps = GenderNavSectionFragmentFragment

export const GenderNavSection: React.FC<GenderNavSectionFragmentFragment> = ({
  alternateGenderHandle,
  selectedGender,
}) => {
  const {
    collections: {
      genderNavSection: { womens, mens },
    },
  } = useTranslation()
  const normalizedGender =
    selectedGender.slice(-1) === 's' ? selectedGender.slice(0, -1) : selectedGender

  return (
    <Container>
      {normalizedGender === 'Women' ? (
        <>
          <SelectedGender>{womens}</SelectedGender>
          <NextLink href={`/collections/${alternateGenderHandle}`}>{mens}</NextLink>
        </>
      ) : (
        <>
          <NextLink href={`/collections/${alternateGenderHandle}`}>{womens}</NextLink>
          <SelectedGender>{mens}</SelectedGender>
        </>
      )}
    </Container>
  )
}
